import { compulsoryColumns, excludedColumns } from "@Components/FileColumnsTreeView/constants";
import axiosWrapper from "@AxiosWrapper";
import { getBackendUrl } from "@Utils";
import type { GetDistinctFilePropertyNamesResponse } from "@ServerTypes/queries/queries.schema";

export const getFilteredColumns = (columns: any) =>
  columns.filter((col: any) => {
    let column = col;
    if (typeof column != "string") {
      column = col.field;
    }
    let includeColumn = true;

    excludedColumns.forEach((excludedColumn: any) => {
      if (excludedColumn.field == column && includeColumn) {
        includeColumn = false;
      }
    });

    compulsoryColumns.forEach((compulsoryColumn: any) => {
      if (compulsoryColumn.field == column && includeColumn) {
        includeColumn = false;
      }
    });

    return includeColumn;
  });

export const getFilePropertyNames = async (fileVersionId: any) => {
  const propertyNames = await axiosWrapper.post<GetDistinctFilePropertyNamesResponse>(
    `${getBackendUrl()}/queries/getDistinctFilePropertyNames`,
    {
      fileVersionId: Array.isArray(fileVersionId) ? fileVersionId : [fileVersionId],
    },
  );

  let columns = [];
  if (propertyNames.data.status) {
    columns = getFilteredColumns((propertyNames.data as any).data);
  }
  return [columns, propertyNames.data];
};

export const convertToDotNotation = (obj: any, parentKey = "", result = {}) => {
  for (const key in obj) {
    if (Object.hasOwn(obj, key)) {
      const newKey = parentKey ? `${parentKey}.${key}` : key;
      const checkForObjectInCustomFields = typeof obj[key] === "object" && parentKey != "customProperties";

      if (
        typeof obj[key] === "object" &&
        obj[key] !== null &&
        !Array.isArray(obj[key]) &&
        checkForObjectInCustomFields
      ) {
        convertToDotNotation(obj[key], newKey, result);
      } else {
        result[newKey] = obj[key];
      }
    }
  }
  return result;
};

export const getModifiedNodesList = (modelProperties: any) => {
  return Object.values(modelProperties)
    .flatMap((v: any) => Object.values(v))
    .map((data: any) => ({
      id: data._id,
      ...convertToDotNotation(data),
    }));
};

export const extractPropertyPartialName = (field: any) => {
  const rootProperty = field.split(".");
  const value = rootProperty.slice(1).join(".").split("/");
  if (value.length > 1) {
    return value.slice(1).join("/");
  }
  return value[0];
};
